export enum LockState {
  Locked,
  Unlocked,
  UnlockedSpecial,
  Unknown,
}
